import { createTheme } from '@mui/material/styles';
import { theme } from '../../../shared/theme';

export const ReviewsCustomTheme = createTheme({
    ...theme,
    breakpoints: {
        values: {
            xs: 0,
            sm: 520,
            md: 770,
            lg: 900,
            xl: 1200,
            xxl: 1600,
            xxxl: 1700,
        },
    },
});
